import { useShadow, useShadowStyle } from "../wcUtil.ts"
import styleText from './shared-modal-styles.css?raw';

export interface ParamateErrorModalContent {
  titleKey: string;
  defaultTitle: string;
  messageKey: string;
  defaultMessage: string;
  sessionId?: string | null;
}

/**
 * Dedicated modal for classified Paramate SDK errors (network/trcad
 * timeout-or-memory/unsupported-file/etc — see paramateErrorInterceptor.ts).
 * Distinct from <as-error-info>, which stays the generic panel for genuinely
 * uncaught JS errors (window.onerror / unhandledrejection).
 *
 * Panels opened via as-app's openModal() are cached/reused by id, so content
 * is set post-construction via setContent() rather than fixed markup.
 */
export class AsModalParamateError extends HTMLElement {
  get html() {
    return /*html*/`
      <div class="panel-content">
        <as-text id="modal-title" class="modal-title"></as-text>
        <as-text id="modal-desc" class="modal-desc"></as-text>
        <as-text id="session-id-line" class="modal-desc" style="margin-top: 1rem; opacity: 0.7; font-size: 0.85em;"></as-text>
        <div class="row option-buttons">
          <as-text-button name="dismiss-paramate-error" variant="primary">OK</as-text-button>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
  }

  setContent(content: ParamateErrorModalContent) {
    const titleEl = this.shadowRoot?.querySelector('#modal-title');
    const descEl = this.shadowRoot?.querySelector('#modal-desc');
    const sessionEl = this.shadowRoot?.querySelector('#session-id-line');

    if (titleEl) {
      titleEl.setAttribute('dict-key', content.titleKey);
      titleEl.textContent = content.defaultTitle;
    }
    if (descEl) {
      descEl.setAttribute('dict-key', content.messageKey);
      descEl.textContent = content.defaultMessage;
    }
    if (sessionEl) {
      sessionEl.textContent = content.sessionId ? `Session ID: ${content.sessionId}` : '';
    }
  }
}

if (!customElements.get('as-modal-paramate-error')) {
  customElements.define('as-modal-paramate-error', AsModalParamateError);
} else {
  console.warn('as-modal-paramate-error already defined');
}
